import { BaseModalUpdateComponent, ModalContainerService, BaseDataService, AuthenticationService, ModalService, NotificationService } from 'yt-ng-framework';
import { Component } from '@angular/core';
import { CompanyRegister } from './company-register';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
// import { NotificationsService } from "angular2-notifications";
// import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'company-selector',
    templateUrl: './company-register.component.html'
})
export class CompanyRegisterComponent
 extends BaseModalUpdateComponent<CompanyRegister>{
    constructor(
        protected modalContainerService: ModalContainerService<CompanyRegister>,
        protected activeModal: NgbActiveModal,
        protected baseDataService: BaseDataService,
        protected router: Router,
        protected authenticationService: AuthenticationService,
        // protected notificationsService: NotificationsService,
        protected toastrService: NotificationService,
        protected modalService: ModalService
    
      ) { 
        super(modalContainerService, activeModal,modalService);
      }
    

    registeringCompany: boolean = false;

    Save(){
        this.baseUpdateComponent.submitted=true;
        if(this.baseUpdateComponent.baseFormGroup.valid){
            this.registeringCompany = true;
            this.baseDataService.Post('registration', 'saveCompany', this.baseUpdateComponent.baseFormGroup.getRawValue(), CompanyRegister, null, null)
                .subscribe((orgJed) => {
                    this.authenticationService.ChangeOrgJed(orgJed)
                        .subscribe(() => {
                            //this.router.navigate(['/login']);
                            this.router.navigate(['/']);
                            this.activeModal.close();
                        }, error => {
                            this.registeringCompany = false;
                            throw error;
                        })
                })
        } else {
            // this.notificationsService.warn(
            //     "Provera",
            //     "Forma nije validna. Proverite unete podatke."
            //   );
              this.toastrService.warning(
                "Provera",
                "Forma nije validna. Proverite unete podatke."
              );
              this.baseUpdateComponent.SaveProcessed.emit(true);
        }
    }
}